import MySurveyComp from '../../Components/MySurvey/MySurveyComp';

function MySurvey() {
  return (
    <>
      <MySurveyComp />
    </>
  );
}

export default MySurvey;
